import {
  CLIENTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  CLIENTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  CLIENTS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  CLIENTS_MASSIVE_UPLOAD_SET_VERIFY,
  CLIENTS_MASSIVE_UPLOAD_CLEAR_VERIFY,
  CLIENTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  CLIENTS_MASSIVE_UPLOAD_SET_UPLOAD,
  CLIENTS_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function clientsMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case CLIENTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case CLIENTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case CLIENTS_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case CLIENTS_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case CLIENTS_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case CLIENTS_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case CLIENTS_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case CLIENTS_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default clientsMassiveUploadReducer;
